export default "__VITE_ASSET__B_17Ebpt__"